import { useCallback } from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';

import { CONTACT_US_URL } from '#client/constants';

import { CANCEL_FLOW_TYPES, getCancelClickstreamProps } from '../utils/cancelFlowConfig';

export function SubscriptionCancelActions({ cancelFlowType, onConfirm, service }) {
  const handleContactCS = useCallback(() => {
    window.location.href = CONTACT_US_URL;
  }, []);

  return (
    <Stack
      gap={2}
      sx={{
        flexDirection: { xs: 'column', sm: 'row' },
        '& > *': { flex: 1 }
      }}
    >
      <Button
        variant="outlined"
        size="large"
        clickstreamProps={getCancelClickstreamProps(cancelFlowType, 'contactCs', service)}
        onClick={handleContactCS}
      >
        <FormattedMessage id="dashboard.subscriptionCancel.actions.contactCS" />
      </Button>
      <Button
        variant="contained"
        size="large"
        clickstreamProps={getCancelClickstreamProps(cancelFlowType, 'confirm', service)}
        onClick={onConfirm}
      >
        <FormattedMessage id="dashboard.subscriptionCancel.reason.continue" />
      </Button>
    </Stack>
  );
}

SubscriptionCancelActions.propTypes = {
  cancelFlowType: PropTypes.oneOf(Object.values(CANCEL_FLOW_TYPES)).isRequired,
  onConfirm: PropTypes.func.isRequired,
  service: PropTypes.string
};
